import { useState } from 'react';
import { maskValue, PHONE_MASK } from '../utils/maskPhone';
import { sendCode, sendPhone } from '../api';

interface IUseAuthorizationProps {
  onAuth: (advertisingAgreement?: boolean) => void;
  onCloseModal?: () => void;
}

export const useAuthorization = ({ onAuth, onCloseModal }: IUseAuthorizationProps) => {
  const [phone, setPhone] = useState('');
  const [uuid, setUuid] = useState<null | string>(null);
  const [codeError, setCodeError] = useState(false);
  const [showAgreements, setShowAgreements] = useState(false);
  const [agreementsChecked, setAgreementsChecked] = useState(false);
  const [advertisingAgreement, setAdvertisingAgreement] = useState(false);
  const [code, setCode] = useState('');

  const maskedPhone = maskValue(phone, PHONE_MASK);

  async function handleSendPhone() {
    if (maskedPhone === null) {
      return;
    }

    const response = await sendPhone(maskedPhone);
    setUuid(response.uuid);
    setCode('');
    setAgreementsChecked(false);
    setAdvertisingAgreement(false);
  }

  function handleResetPhone() {
    setUuid(null);
    setCode('');
    setAgreementsChecked(false);
    setAdvertisingAgreement(false);
    setCodeError(false);
  }

  async function handleSendCode(code: string) {
    if (uuid === null) {
      return;
    }

    const response = await sendCode(uuid, code, advertisingAgreement);

    if (response.ok) {
      onAuth(advertisingAgreement);
      onCloseModal?.();
    } else {
      setCodeError(true);
    }
  }

  return {
    phone,
    setPhone,
    uuid,
    setUuid,
    codeError,
    setCodeError,
    showAgreements,
    setShowAgreements,
    agreementsChecked,
    setAgreementsChecked,
    advertisingAgreement,
    setAdvertisingAgreement,
    code,
    setCode,
    maskedPhone,
    handleSendPhone,
    handleResetPhone,
    handleSendCode,
  };
};
